module.exports = __webpack_public_path__ + "static/media/LY.89d2a6ca.svg";